import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.dismiss()
    }, 3000)
  }

  dismiss() {
    this.element.style.transition = "opacity 0.6s ease, transform 0.6s ease"
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-6px)"
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
  }
}
